module.exports = __webpack_public_path__ + "static/Masterclass-header-3fa0eb68b2aee84a607bac9095b31c7a.jpg";